import axiosInstance from "@/Axios/ConfiguredAxios";

const validateMissingCodes = async (shouldExistColumns, nullableColumns, parsedData) => {
  const errors = [];

  await Promise.all(
    Object.entries(shouldExistColumns).map(async ([entity, columnValue]) => {
      const normalizedColumnValue = columnValue.toLowerCase();

      try {
        let payload = parsedData
          .map((row, index) => ({
            row: index + 2,
            code: row[normalizedColumnValue],
          }));

        // allow null codes if column is nullable
        if (nullableColumns.map(c => c.toLowerCase()).includes(normalizedColumnValue)) {
          payload = payload.filter(p => p.code);

          if (payload.length === 0) {
            return;
          }
        }

        let newEntity = entity;

        await axiosInstance.post(`${newEntity}/import/validate-missing-codes`, {
          codes: payload,
        });

      } catch (error) {
        const responseErrors = error.response?.data?.errors;
        errors.push(...responseErrors);
      }
    })
  );

  return errors.sort((a, b) => a.row - b.row);
};

export default validateMissingCodes;
